import FollowUpEmailCard from "./FollowUpEmailCard";
import NotificationCard from "./NotificationCard";

function DCLDetails({ dcl }) {

    const list = dcl?.metadata ? JSON.parse(dcl?.metadata) : []

    const dclComponents = {
        "brg-patient-email-reminder": (data) => {
            return (
                <FollowUpEmailCard metadata={data} />
            )
        },

        "daily-user-update-notification": (data) => {
            return (
                <NotificationCard metadata={data} />
            )
        }
    }

    return (
        <div id="dcl-details">
            {
                dclComponents?.[dcl?.type] && dclComponents?.[dcl?.type](dcl?.metadata ? JSON.parse(dcl?.metadata) : null)
            }
        </div>
    );
}

export default DCLDetails;